module.exports = __webpack_public_path__ + "static/illustration-ad324eff4a4dc626503ad3252f32dfc6.png";